export function shouldFetchTheme(subdirectory) {
    const lastFetched = localStorage.getItem(`${subdirectory}-themeFetchedAt`);

    if (!lastFetched) return true;

    const lastFetchedTime = new Date(lastFetched).getTime();
    const now = Date.now();

    const oneDayInMs = 24 * 60 * 60 * 1000;

    return (now - lastFetchedTime) > oneDayInMs;
}